const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.m4v'];

export function isVideoMedia(url: string): boolean {
  const path = url.split('?')[0]?.toLowerCase() ?? '';
  return VIDEO_EXTENSIONS.some((extension) => path.endsWith(extension));
}
